import '../components/hs-progress-bar';

export default {

  init() {
    // JavaScript to be fired on the single enrolment page
    
    // initialization of horizontal progress bars
    const horizontalProgressBars = $.HSCore.components.HSProgressBar.init('.js-hr-progress', {
        direction: 'horizontal',
        indicatorSelector: '.js-hr-progress-bar'
      });

    },
  finalize() {
    // JavaScript to be fired on the my-account page
    
    //open popup
    $('#loader_popup').modal({
      backdrop: 'static',
      keyboard: false
    }); 

    $(".remove-enrolment-button").on("click", function () {
      var enrolment_id = $(this).data("enrolment-id");
      var course_name = $(this).data("course-name");
      $('#enrolmentcoursename').html('" ' + course_name + ' "');
      $('#removeenrolment').data('enrolment-id',enrolment_id);
      $('#remove_enrolment_popup').modal('show'); 
    });

    $("#cancelenrolment").on("click",  function() {
      $('#remove_enrolment_popup').modal('hide');
    })

    $(".remove-enrolment").on("click", function () {
        var enrolment_id = $(this).data("enrolment-id");
        var action="removeenrolment";
        var url = ajaxdta.ajaxurl + "?action=remove_enrolment";
        $(".modal-closebutton").hide();
        $("#fullenrolment").addClass('d-none');
        $("#fullenrolment").hide();
        $("#loading_button_remove").removeClass('d-none');
        $("#loading_button_remove").show();

        $.ajax({
          type: "POST",
          url: url,
          data: {
            enrolment_id: enrolment_id, action:action
          },
          dataType:"JSON",
            success: function (data) {
                $('#remove_enrolment_popup').modal('hide');  
                var mString = data.success;
                if(mString){
                  $("#enrolmentdiv"+ enrolment_id).hide(); 
                  $("#loading_button_remove").addClass('d-none');
                  $("#loading_button_remove").hide();
                  $("#fullenrolment").removeClass('d-none');
                  $("#fullenrolment").show();
                  location.href = "/my-enrolments";
                }          
              },
          });
      });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-enrolment.js